import { Icon } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { queryKeys } from '~/routes/app-paths';

import {
  RANKING_METHODOLOGY_DRAWER_ID,
  RankingMethodologyDrawer,
  RankingMethodologyType,
} from '../../../ranking-methodology-drawer/RankingMethodologyDrawer';
import * as S from './RankingMethodologySection.styles';

export const RankingMethodologySection = ({
  rankingType,
}: {
  rankingType: RankingMethodologyType;
}) => {
  const { t } = useTranslation(['widget']);
  const { setQueryParams } = useQueryParams();

  return (
    <>
      <RankingMethodologyDrawer />
      <S.RankingMethodologyWrapper>
        <S.LabelWrapper>
          <Icon
            iconName="InformationCircle"
            size={20}
            fillColor="var(--icon-soft)"
          />
          <S.StyledLabel>
            {t(
              'widget:assetOverview.knowledgeGraph.themeExposure.rankIsCalculated'
            )}
          </S.StyledLabel>
        </S.LabelWrapper>
        <S.StyledButton
          variant="tertiary"
          label={t(
            'widget:assetOverview.knowledgeGraph.themeExposure.viewMethodology'
          )}
          onClick={() =>
            setQueryParams({
              [queryKeys.activeDrawer]: RANKING_METHODOLOGY_DRAWER_ID,
              [queryKeys.mode]: rankingType,
            })
          }
        />
      </S.RankingMethodologyWrapper>
    </>
  );
};
